import gql from "graphql-tag"

export default gql`
  {
    canImpersonate
    currentUser {
      permissions
      availableProducts {
        xtm: isXtmContract
        xtp: isXtpContract
      }
      isImpersonated
    }
  }
`
